define([
	"dojo/_base/declare",
	"csi/heading/Ref",
], function(declare, Ref) {

	return declare(Ref, {
		getNodeDisplayName: function(/*Context*/ctx, /*Node*/node) {
			// summary: return name of referenced node
			if (node.$Type != "TestRun") {
				return ctx.cache.getNode(node.__Parent__).$Name + " - " + node.$Name;
			}

			return this.inherited(arguments, [ctx, node]);
		}
	});
});